import { marker } from "@jsverse/transloco-keys-manager/marker";
import { from, Observable, of, zip } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import {
  loadDemoStorage,
  writeDemoStorage
} from "src/app/support/demo-storage";
import { UserNotify } from "src/app/support/notify-decorator";
import { rxRandomErrorDelayAsync } from "src/app/support/rx-random-error-delay";
import { uuid } from "src/app/support/uuid";
import { TemplateEmail } from "../../models/template-email/template-email";
import { TemplateEmailCreate } from "../../models/template-email/template-email.create";
import { TemplateEmailLoad } from "../../models/template-email/template-email.load";
import { TemplateEmailUpdate } from "../../models/template-email/template-email.update";
import { TemplateEmailBackend } from "./template-email.backend";

const DB_NAME = "template-email";

export class TemplateEmailMockBackend extends TemplateEmailBackend {
  loadTypes(): Observable<string[]> {
    return rxRandomErrorDelayAsync(
      Promise.resolve(["CODICE_VERIFICA", "CONTINUA_DOPO", "NUOVO_MEMBRO"])
    );
  }

  list(): Observable<TemplateEmail[]> {
    return from(loadDb());
  }

  load(request: TemplateEmailLoad): Observable<TemplateEmail> {
    return from(loadDb()).pipe(
      map((list) => {
        return list.find((x) => x.id === request.id)!;
      })
    );
  }

  @UserNotify({
    successMessage: marker("Modello creato"),
    errorMessage: marker("Impossibile creare il modello")
  })
  create(request: TemplateEmailCreate): Observable<string> {
    return from(loadDb()).pipe(
      switchMap((list) => {
        const newUuid = uuid();
        const newTemplateEmail: Partial<TemplateEmail> = {
          id: newUuid,
          type: request.type
        };

        return from(
          writeDemoStorage(DB_NAME, [...list, newTemplateEmail])
        ).pipe(map(() => newUuid));
      })
    );
  }

  @UserNotify({
    errorMessage: marker("Impossibile aggiornare il modello")
  })
  update(request: TemplateEmailUpdate): Observable<void> {
    return from(loadDb()).pipe(
      switchMap((list) => {
        return from(
          writeDemoStorage(
            DB_NAME,
            list.map((x) => {
              if (x.id === request.id) {
                return {
                  ...x,
                  ...request
                };
              }

              return x;
            })
          )
        );
      })
    );
  }
}

async function loadDb(): Promise<TemplateEmail[]> {
  return (await loadDemoStorage<TemplateEmail[]>(DB_NAME)) || [];
}
